import { render } from "./Index.vue?vue&type=template&id=fda11bde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=fda11bde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fda11bde"

export default script